// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"np-z","breadcrumbForward":"op-z","breadcrumbBack":"pp-z","selected":"qp-z"};